export const handleRowColor = (jobInvoiceState, isActiveRow, accountingState) => {
  const color = 'white';
  if (isActiveRow) {
    return '#A7A6A6';
  }

  /* NOTE: for unknown accounting_state, because of deleted in sage, we want to color yellow
  * In current implementation, job state is completed instead of updated to invoicable */
  if (accountingState === 'unknown') {
    return '#FFEEBA';
  }

  if (jobInvoiceState === 'invoicing') {
    return '#96E4FF';
  }

  if (jobInvoiceState === 'invoiced') {
    return null;
  }

  return color;
};
